export default __webpack_public_path__ + "app/images/ls-logo-big.png";